import React from "react";
import {
  FaDribbble,
  FaTwitter,
  FaInstagram,
  FaEnvelope,
  FaWhatsapp,
  FaLinkedin,
  FaGithub,
} from "react-icons/fa";
import hero from ".././Assets/kishore_profile.png";
// import dev from '.././Assets/developer.png'

const ProfileCard = () => {
  return (
    <><div className="flex static md:fixed mx-auto ml-0 md:ml-16 md:-mt-20  -mt-2 justify-center items-center md:h-screen ">
      <div className="relative bg-white p-6 rounded-2xl shadow-lg max-w-xs mb-8   md:max-w-sm lg:max-w-sm text-center">
        {/* Profile Image */}
        <div className="bg-gradient-to-b from-[#914EEE] to-black rounded-xl">
          <img src={hero} alt="Profile" className="rounded-xl object-contain" />
        </div>

        {/* Name */}
        <h2 className="text-3xl font-bold text-black mt-4">Kishore S</h2>
        <p className="text-sm text-gray-600 font-medium">
          Software Developer | SEO Expert | Meta MakePerfect Strategist
        </p>
        {/* Description */}
        <p className="text-gray-500 text-sm mt-2">
          A Software Engineer who has developed countless innovative solutions.
        </p>

        {/* Social Media Icons with Links */}
        <div className="flex justify-center space-x-4 mt-4 text-[#914EEE]">
          <a
            href="https://linkedin.com/in/kishore-s-5a5358241"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="linkdin"
          >
            <FaLinkedin className="text-lg cursor-pointer" />
          </a>
          <a
            href="https://wa.me/918940281615"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
          >
            <FaWhatsapp className="text-lg cursor-pointer" />
          </a>



          <a
            href="https://github.com/Kishore174"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="github"
          >
            <FaGithub className="text-lg cursor-pointer" />
          </a>

          <a
            href="mailto:skishore17@gmail.com.com"
            aria-label="Email"
          >
            <FaEnvelope className="text-lg cursor-pointer" />
          </a>
        </div>
      </div>
    </div>
    {/* <div className="bg-white flex items-center justify-between px-4 py-3 border-t rounded-b-2xl">
        <div className="flex items-center space-x-3">
          <img
            src={hero}
            alt="Kishore"
            className="w-10 h-10 rounded-full border border-gray-200" />
          <div className="text-left">
            <p className="text-sm font-semibold text-gray-800">Message Kishore</p>
            <p className="text-xs text-green-500 font-medium">● Online</p>
          </div>
        </div>
        <p className="text-xs text-gray-500">Avg. response: 1 hr</p>
      </div> */}
      </>
  );
};

export default ProfileCard;
